import { render, staticRenderFns } from "./HelloWorldPage2.vue?vue&type=template&id=6b9cda7d&"
import script from "./HelloWorldPage2.vue?vue&type=script&lang=ts&"
export * from "./HelloWorldPage2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports